import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient) { }

  downloadFile(projectId: number, objectId: number, uploadId: number, fileId: number, filename: string): Observable<Blob> {
    var url = `${environment.apiUrl}/projects/${projectId}/objects/${objectId}/uploads/${uploadId}/files/${fileId}/download/${filename}`;
    return this.http.get(url, { responseType: 'blob' });
  }
  downloadAllFiles(projectId: number, objectId: number, uploadId: number, fileId: number, filename: string): Observable<any> {
    var url = `${environment.apiUrl}/projects/${projectId}/objects/${objectId}/uploads/${uploadId}/files/${fileId}/download`;
    const params = new HttpParams().set('name', filename);
    return this.http.get(url, {
      params,
      responseType: 'blob', reportProgress: true,
      observe: 'events'
    });
  }
}
